import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.regexp.constructor";
import "core-js/modules/es6.array.for-each";
import _classCallCheck from "/Users/dlynch/code/websites/mathapedia.com/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/dlynch/code/websites/mathapedia.com/node_modules/@babel/runtime/helpers/esm/createClass";
import TextExt from './lib/text';
import HeadersExt from './lib/headers';
import { pstricks as PSTricksExt } from 'latex2js-pstricks';
import EnvironmentsDefault from './lib/environments';
import IgnoreDefault from './lib/ignore';
import Parser from './lib/parser';

var LaTeX2HTML5 =
/*#__PURE__*/
function () {
  function LaTeX2HTML5() {
    var _this = this;

    var Text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : TextExt;
    var Headers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : HeadersExt;
    var Environments = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : EnvironmentsDefault;
    var Ignore = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : IgnoreDefault;
    var PSTricks = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : PSTricksExt;
    var Views = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};

    _classCallCheck(this, LaTeX2HTML5);

    this.Text = Text;
    this.Headers = Headers;
    this.Environments = Environments;
    this.Ignore = Ignore;
    this.PSTricks = PSTricks;
    this.Views = Views;
    this.Delimiters = {};
    Environments.forEach(function (name) {
      _this.addEnvironment(name);
    });
  }

  _createClass(LaTeX2HTML5, [{
    key: "addEnvironment",
    value: function addEnvironment(name) {
      var delim = {
        begin: new RegExp('\\\\begin\\{' + name + '\\}'),
        end: new RegExp('\\\\end\\{' + name + '\\}')
      };
      this.Delimiters[name] = delim;
    }
  }, {
    key: "addView",
    value: function addView(name, options) {
      this.addEnvironment(name); // var view = {};
      // this.Views[name] = this.BaseEnvView.extend(options);
    }
  }, {
    key: "addText",
    value: function addText(name, exp, func) {
      this.Text.Expressions[name] = exp;
      this.Text.Functions[name] = func;
    }
  }, {
    key: "addHeaders",
    value: function addHeaders(name, begin, end) {
      var exp = {};
      var beginHash = name + 'begin';
      var endHash = name + 'end';
      exp[beginHash] = new RegExp('\\\\begin\\{' + name + '\\}');
      exp[endHash] = new RegExp('\\\\end\\{' + name + '\\}');
      Object.assign(this.Headers.Expressions, exp);
      var fns = {};

      fns[beginHash] = function () {
        return begin || '';
      };

      fns[endHash] = function () {
        return end || '';
      };

      Object.assign(this.Headers.Functions, fns);
    }
  }, {
    key: "getParser",
    value: function getParser() {
      return new Parser(this);
    }
  }, {
    key: "parse",
    value: function parse(text) {
      var parser = new Parser(this);
      var parsed = parser.parse(text);
      parsed.forEach(function (element) {
        if (!element.hasOwnProperty('type')) {
          throw new Error('no type!');
        } // TODO implement rendering

      });
      return parsed;
    }
  }]);

  return LaTeX2HTML5;
}();

export { LaTeX2HTML5 as default };